import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import persist from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import RouterApp from "./routes";



import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/custom_styles/globals.scss";


const { persistor, store } = persist();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterApp />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

reportWebVitals();
